import { gql } from '@apollo/client';

export const TEXT_TO_SPEECH = gql`
    mutation($data: TextToSpeechInput!) {
        textToSpeech(data: $data) {
            ... on Message {
                id
                title
                body
                createdAt
                updatedAt
                file {
                    url
                    cdn_url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    mime
                    width
                    height
                    aspect_ratio
                    duration
                }
            }
            ... on TextToSpeechQueued {
                message
                requestId
                sourceMessageId
                state
            }
            ... on TextToSpeechError {
                message
            }
        }
    }
`;
